import React from 'react';

const PokedexLogo = ({ size = 'normal', animate = false }) => {
  const sizes = {
    small: { 
      container: 'w-8 h-8', 
      text: 'text-base', 
      title: 'text-lg',
      letterSize: 'text-sm font-bold'
    },
    normal: { 
      container: 'w-10 h-10', 
      text: 'text-xl', 
      title: 'text-2xl',
      letterSize: 'text-xl font-bold'
    },
    large: { 
      container: 'w-12 h-12', 
      text: 'text-2xl', 
      title: 'text-3xl',
      letterSize: 'text-2xl font-bold'
    }
  };

  const currentSize = sizes[size] || sizes.normal;

  return (
    <div className="flex items-center space-x-2 group" style={{ display: 'inline-flex' }}>
      <div
        className={`${currentSize.container} rounded-full flex items-center justify-center shadow-lg transition-all ${animate ? 'group-hover:animate-spin-slow' : ''}`}
        style={{
          background: 'linear-gradient(135deg, #ff0000 0%, #cc0000 100%)',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06), 0 0 20px rgba(255, 0, 0, 0.2)'
        }}
      >
        <span className={`text-white ${currentSize.letterSize}`}>P</span>
      </div>
      <span
        className={`${currentSize.title} font-bold`}
        style={{
          background: 'linear-gradient(90deg, #ff0000 0%, #3b82f6 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
        }}
      >
        Pokédex
      </span>
    </div>
  );
};

export default PokedexLogo;